import React, { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { Calendar, MessageSquare, User, ArrowLeft, Tag } from "lucide-react";
import SiteHeader from "../components/SiteHeader";
import Footer from "../components/Footer";
import PageBanner from "../components/PageBanner";
import Reveal from "../components/Reveal";
import { posts } from "./Blog";

const SinglePost = () => {
  const { slug } = useParams();
  const post = posts.find((p) => `${p.slug}.html` === slug || p.slug === slug) || posts[1];

  useEffect(() => { document.title = `${post.title} – Moggies & Doggies Veterinary Care`; }, [post.title]);

  return (
    <div className="min-h-screen bg-white font-body text-pawelle-body">
      <SiteHeader />
      <main>
        <PageBanner title="Single Post" subtitle={post.title} crumbs={["Blog", "Post"]} />

        <article className="mx-auto max-w-[860px] px-5 py-16 md:py-24">
          <Reveal animation="fadeInUp">
            <div className="flex flex-wrap items-center gap-5 font-body text-[14px] text-pawelle-body">
              <span className="inline-flex items-center gap-1.5"><Tag className="h-4 w-4 text-pawelle-primary" /> {post.cat}</span>
              <span className="inline-flex items-center gap-1.5"><Calendar className="h-4 w-4 text-pawelle-primary" /> November 10, 2025</span>
              <span className="inline-flex items-center gap-1.5"><User className="h-4 w-4 text-pawelle-primary" /> Admin</span>
              <span className="inline-flex items-center gap-1.5"><MessageSquare className="h-4 w-4 text-pawelle-primary" /> No Comments</span>
            </div>
            <h1 className="mt-5 font-display text-[32px] font-bold leading-tight text-pawelle-ink md:text-[42px]">{post.title}</h1>
          </Reveal>

          <Reveal animation="fadeInUp" delay={100}>
            <img src={`/pawelle/${post.img}`} alt={post.title} className="mt-8 w-full rounded-[28px] object-cover shadow-[0_24px_60px_rgba(67,48,109,0.12)]" />
          </Reveal>

          <Reveal animation="fadeInUp" delay={150} className="mt-10 space-y-5 font-body text-[16px] leading-relaxed text-pawelle-body">
            <p>
              Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa.
              Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis,
              ultricies nec, pellentesque eu, pretium quis, sem.
            </p>
            <p>
              Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In
              enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium.
            </p>
            <blockquote className="rounded-2xl border-l-4 border-pawelle-primary bg-pawelle-bg px-6 py-5 font-display text-[18px] font-medium text-pawelle-ink">
              "Compassion and expertise, together in every visit — that's the heart of great veterinary care."
            </blockquote>
            <p>
              Vivamus elementum semper nisi. Aenean vulputate eleifend tellus. Aenean leo ligula, porttitor eu,
              consequat vitae, eleifend ac, enim. Aliquam lorem ante, dapibus in, viverra quis, feugiat a, tellus.
            </p>
          </Reveal>

          <div className="mt-12">
            <Link to="/gb/en/blog.html" className="inline-flex items-center gap-2 rounded-full bg-pawelle-primary px-6 py-3 font-display text-[15px] font-medium text-white transition-all duration-300 hover:bg-pawelle-primary-dark">
              <ArrowLeft className="h-4 w-4" /> Back to Blog
            </Link>
          </div>
        </article>
      </main>
      <Footer />
    </div>
  );
};

export default SinglePost;
